import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-109">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/80 z-40" data-id="element-110" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.2
      }} className="fixed inset-4 md:inset-auto md:left-1/2 md:top-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:w-full md:max-w-3xl md:max-h-[85vh] bg-navy-medium border-2 border-gold/30 rounded-lg shadow-2xl z-50 flex flex-col" data-id="element-111">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-gold/20" data-id="element-112">
              <h2 className="font-heading text-2xl md:text-3xl text-gold" data-id="element-113">
                {title}
              </h2>
              <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors p-2 rounded-lg hover:bg-navy-dark" aria-label="Cerrar modal" data-id="element-114">
                <X className="w-6 h-6" data-id="element-115" />
              </button>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-y-auto p-6" data-id="element-116">
              <div className="prose prose-invert max-w-none" data-id="element-117">{children}</div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}